import { render } from "./WeeklyRecipe.vue?vue&type=template&id=b3b6cc8c&scoped=true"
import script from "./WeeklyRecipe.vue?vue&type=script&lang=js"
export * from "./WeeklyRecipe.vue?vue&type=script&lang=js"

import "./WeeklyRecipe.vue?vue&type=style&index=0&id=b3b6cc8c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3b6cc8c"]])

export default __exports__